'use client'

import { useState, useEffect } from 'react'
import {
  Box,
  Button,
  Input,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Textarea,
  Select,
  Heading,
  VStack,
  HStack,
  IconButton,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useColorModeValue
} from '@chakra-ui/react'
import { PlusSquareIcon, DeleteIcon } from '@chakra-ui/icons'
import { useParams } from 'react-router-dom'
import JobsController from 'controllers/Jobs/JobsController'
import CampanhasController from 'controllers/Campanhas/CampanhasController'

export default function ClassificationInsightView() {
  const [selectedCampaign, setSelectedCampaign] = useState('')
  const [activeMainTab, setActiveMainTab] = useState('insights')
  const [insights, setInsights] = useState([])
  const [newInsightName, setNewInsightName] = useState('')
  const [newInsightPrompt, setNewInsightPrompt] = useState('')

  const [classifications, setClassifications] = useState([])
  const [newClassificationName, setNewClassificationName] = useState('')
  const [newClassificationPrompt, setNewClassificationPrompt] = useState('')

  const [campaigns, setCampaigns] = useState([])
  const [newCampaignName, setNewCampaignName] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { description, idcampanhas } = useParams()

  const fetchCampaigns = async () => {
    try {
      const fetchedCampaigns = await CampanhasController.ListCampaigns();
      setCampaigns(fetchedCampaigns);
      if (fetchedCampaigns.length > 0) {
        setSelectedCampaign(fetchedCampaigns[0].id);
      }
    } catch (error) {
      console.error('Erro ao buscar campanhas:', error);
    }
  }

  const fetchClassifications = async (campaignId) => {
    try {
      const fetchedClassifications = await JobsController.GetClassifications(campaignId);
      console.log('Fetched Classifications:', fetchedClassifications);
      setClassifications(fetchedClassifications || []);
    } catch (error) {
      console.error('Erro ao buscar classificações:', error);
      setClassifications([]);
    }
  };

  useEffect(() => {
    if (selectedCampaign) {
      fetchClassifications(selectedCampaign);
      console.log('Selected Campaign:', selectedCampaign);
    }
  }, [selectedCampaign]);

  const filteredClassifications = classifications.filter(classification => classification.id_campanha === Number(selectedCampaign));

  const addInsight = async () => {
    if (newInsightName && newInsightPrompt) {
      try {
        const newInsight = await JobsController.AddInsights(newInsightName, newInsightPrompt, idcampanhas);
        setInsights([...insights, { id: newInsight.result.id, nome: newInsightName, prompt: newInsightPrompt }]);
        setNewInsightName('')
        setNewInsightPrompt('')
      } catch (error) {
        console.error('Erro ao adicionar insight:', error);
      }
    }
  }

  const deleteInsight = async (id) => {
    try {
      await JobsController.DeleteInsight(id);
      setInsights(insights.filter((insight) => insight.id !== id));
    } catch (error) {
      console.error('Erro ao deletar insight:', error);
    }
  };

  const addClassification = async () => {
    if (newClassificationName && newClassificationPrompt) {
      try {
        const NewClassification = await JobsController.AddClassification(newClassificationName, newClassificationPrompt, selectedCampaign, idcampanhas);
        setClassifications([...classifications, { id_campanha: NewClassification.result.id_campanha, nome: newClassificationName, classificacao: newClassificationPrompt }]);
        setNewClassificationName('')
        setNewClassificationPrompt('')
      } catch (error) {
        console.error('Erro ao adicionar insight:', error);
      }
    }
  }

  const deleteClassification = async (id) => {
    try {
      await JobsController.DeleteClassification(id);
      setClassifications(classifications.filter((classification) => classification.id !== id))
    } catch (error) {
      console.error('Erro ao deletar insight:', error);
    }
  };

  const addCampaign = async () => {
    if (newCampaignName) {
      try {
        const newCampaign = await CampanhasController.AddCampaigns(newCampaignName, idcampanhas);
        setCampaigns([...campaigns, newCampaign.result]);
        setSelectedCampaign(newCampaign.result.id);
        setNewCampaignName('');
        setIsModalOpen(false);
      } catch (error) {
        console.error('Erro ao adicionar campanha:', error);
      }
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await JobsController.GetInsights(idcampanhas)
        if (response) {
          setInsights(response)
        } else {
          setInsights([])
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        setInsights([])
      }
    }
    fetchData(idcampanhas)
  }, [idcampanhas]);

  useEffect(() => {
    fetchCampaigns();
  }, []);

  console.log('Renderizando Classificações:', filteredClassifications.length);

  const bgColorCard = useColorModeValue("white", "");

  return (
    <Box height="100vh" width="100vw" p={4} overflowY="auto" style={{ backgroundColor: bgColorCard }} >
      <Box borderWidth="1px" borderRadius="lg" p={6} height="100%" width="100%">
        <Heading as="h2" size="xl" mb={4}>
          OPERAÇÃO: {description}
        </Heading>
        <Tabs isFitted variant="enclosed" index={activeMainTab === 'insights' ? 0 : 1} onChange={(index) => setActiveMainTab(index === 0 ? 'insights' : 'campanha')}>
          <TabList mb={4}>
            <Tab>Insights</Tab>
            <Tab>Campanhas</Tab>
          </TabList>

          <TabPanels height="100%">
            <TabPanel>
              <Box borderWidth="1px" borderRadius="lg" p={4} height="100%">
                <Heading as="h3" size="lg" mb={4}>
                  Insights
                </Heading>
                <Text mb={4}>Gerencie os insights da campanha</Text>
                <VStack spacing={4}>
                  <HStack width="full" spacing={4}>
                    <Input
                      placeholder="Nome do Insight"
                      value={newInsightName}
                      onChange={(e) => setNewInsightName(e.target.value)}
                    />
                    <Button colorScheme="blue" onClick={addInsight} borderRadius="md">
                      <PlusSquareIcon mr={2} /> Adicionar
                    </Button>
                  </HStack>
                  <Textarea
                    placeholder="Prompt do Insight"
                    value={newInsightPrompt}
                    onChange={(e) => setNewInsightPrompt(e.target.value)}
                  />
                  <Box maxHeight="200px" width="full" overflowY="auto" borderWidth="1px" borderRadius="md" p={4}>
                    {insights.length > 0 ? (
                      insights.map((insight) => (
                        <HStack key={insight.id} justify="space-between" align="start" mb={4}>
                          <Box>
                            <Heading as="h4" size="md">{insight.nome}</Heading>
                            <Text fontSize="sm" color="gray.500">{insight.prompt}</Text>
                          </Box>
                          <IconButton
                            aria-label="Delete Insight"
                            icon={<DeleteIcon />}
                            onClick={() => deleteInsight(insight.id)}
                          />
                        </HStack>
                      ))
                    ) : (
                      <Text>Nenhum insight disponível</Text>
                    )}
                  </Box>
                </VStack>
              </Box>
            </TabPanel>
            <TabPanel>
              <Box borderWidth="1px" borderRadius="lg" p={4} height="100%">
                <Heading as="h3" size="lg" mb={4}>
                  Classificações
                </Heading>
                <HStack justify="space-between" mb={4}>
                  <Text>Selecione uma campanha e gerencie as classificações</Text>
                  <Button colorScheme="blue" onClick={() => setIsModalOpen(true)} borderRadius="md">
                    Adicionar Campanha
                  </Button>
                </HStack>
                <VStack spacing={4} height="100%" overflowY="hidden">
                  <Select
                    value={selectedCampaign}
                    onChange={(e) => setSelectedCampaign(e.target.value)}
                  >
                    <option value="" disabled>Selecionar a Campanha</option>
                    {campaigns.length > 0 ? (
                      campaigns.map((campaign) => (
                        <option key={campaign.id} value={campaign.idcampanhas}>
                          {campaign.campanha_nome}
                        </option>
                      ))
                    ) : (
                      <option>Nenhuma campanha disponível</option>
                    )}
                  </Select>
                  <HStack width="full" spacing={4}>
                    <Input
                      placeholder="Nome da Classificação"
                      value={newClassificationName}
                      onChange={(e) => setNewClassificationName(e.target.value)}
                    />
                    <Button colorScheme="blue" onClick={addClassification} borderRadius="md">
                      <PlusSquareIcon mr={2} /> Adicionar
                    </Button>
                  </HStack>
                  <Textarea
                    placeholder="Prompt da Classificação"
                    value={newClassificationPrompt}
                    onChange={(e) => setNewClassificationPrompt(e.target.value)}
                  />
                  <Box maxHeight="130px" width="full" overflowY="auto" borderWidth="1px" borderRadius="md" p={4}>
                    {filteredClassifications.length > 0 ? (
                      filteredClassifications.map((classification) => (
                        <HStack key={classification.id} justify="space-between" align="start" mb={4}>
                          <Box>

                            <Heading as="h4" size="md">{classification.nome || "Nome não disponível"}</Heading>
                            <Text fontSize="sm" color="gray.500">{classification.classificacao}</Text>
                          </Box>
                          <IconButton
                            aria-label="Delete Classification"
                            icon={<DeleteIcon />}
                            onClick={() => deleteClassification(classification.id)}
                          />
                        </HStack>
                      ))
                    ) : (
                      <Text>Nenhuma classificação disponível</Text>
                    )}
                  </Box>
                </VStack>
              </Box>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box >
      < Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)
      }>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Adicionar Nova Campanha</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Input
              placeholder="Nome da Nova Campanha"
              value={newCampaignName}
              onChange={(e) => setNewCampaignName(e.target.value)}
            />
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={addCampaign} borderRadius="md">
              Adicionar
            </Button>
            <Button onClick={() => setIsModalOpen(false)} ml={3} borderRadius="md">
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal >
    </Box >
  )
}
